import { ScheduledMessageFormKey } from '@asset/enum/chatEnum';
import { ExpandMoreIcon } from '@asset/svg/Expand';
import { ScheduledMessageForm } from '@asset/type/chat';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/components/ui/dropdown-menu';
import { UseFormReturn } from 'react-hook-form';
import * as S from '@styles/chat/scheduleMessage.style';
import { STUDENT_SELECTOR_CONTENT_CLASS_NAME } from 'constants/chat';

function StudentSelector({
  scheduledMessageForm,
  students,
}: {
  scheduledMessageForm: UseFormReturn<ScheduledMessageForm>;
  students: {
    id: number;
    name: string;
    schoolName: string;
    sendbirdChannelUrl: string;
  }[];
}) {
  return (
    <>
      <S.StudentSelectorGlobalStyle />
      <S.StudentSelector>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button>
              {scheduledMessageForm.getValues(ScheduledMessageFormKey.RECIPIENT)
                ?.name ?? '-'}
              <ExpandMoreIcon width="16" height="16" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className={STUDENT_SELECTOR_CONTENT_CLASS_NAME}
            side="right"
            align="start"
          >
            {students.map((student) => (
              <DropdownMenuItem
                key={student.id}
                onClick={() => {
                  scheduledMessageForm.setValue(
                    ScheduledMessageFormKey.RECIPIENT,
                    {
                      name: student.name,
                      channelUrl: student.sendbirdChannelUrl,
                    },
                    { shouldDirty: true },
                  );
                }}
              >
                <span>{student.name}</span>
                <span>{student.schoolName}</span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </S.StudentSelector>
    </>
  );
}

export default StudentSelector;
